import * as Sentry from "@sentry/react";
import { SUBSCRIPTION_INVOICES_URL } from "../constants/endpoints";
import axiosClient from "./axios";

class FetchSubscriptionInvoicesService {
  static async fetchSubscriptionInvoices(
    shopId: string,
    page: number,
    limit: number
  ) {
    const url = SUBSCRIPTION_INVOICES_URL.replace("{shopId}", shopId);

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "POST /admin/chargeAtWill/subscription/invoices/{shopId}",
      },
      async () => {
        return axiosClient.post(url, { page, limit });
      }
    );
  }
}

export default FetchSubscriptionInvoicesService;
